import { FC } from 'react';
import { Skeleton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { QcsTooltip } from '../../common/basic/QcsTooltip';
import {
  KpiInfoIcon,
  KpiLabel,
  KpiLabelRow,
  KpiRoot,
  KpiValue,
} from './KpiTileStyles';

interface Props {
  labelKey: string;
  tooltipKey?: string;
  value: string | number;
  tone?: 'neutral' | 'positive' | 'muted';
  loading?: boolean;
}

export const KpiTile: FC<Props> = ({
  labelKey,
  tooltipKey,
  value,
  tone = 'neutral',
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <KpiRoot>
      <KpiLabelRow>
        <KpiLabel>{t(labelKey)}</KpiLabel>
        {tooltipKey && (
          <QcsTooltip title={t(tooltipKey)} placement="top">
            <KpiInfoIcon>
              <InfoOutlinedIcon />
            </KpiInfoIcon>
          </QcsTooltip>
        )}
      </KpiLabelRow>
      {loading ? (
        <Skeleton variant="text" width="60%" height={32} />
      ) : (
        <KpiValue tone={tone}>{value}</KpiValue>
      )}
    </KpiRoot>
  );
};
